(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.best-sellers__tab');
    if (!tab) return;
    var root = tab.closest('.best-sellers');
    var idx = tab.getAttribute('data-tab');
    root.querySelectorAll('.best-sellers__tab').forEach(function (t) {
      var active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('.best-sellers__panel').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-panel') === idx);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var SECTION = 'cart-drawer';
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
    }

    function updateBadge(count) {
      var badge = document.querySelector('[data-cart-count]');
      if (!badge) return;
      badge.textContent = count;
      badge.hidden = count < 1;
    }

    // Swap the drawer contents with a freshly rendered section, update the badge.
    function applySection(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-contents]');
      var current = drawer.querySelector('[data-cart-contents]');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        updateBadge(parseInt(fresh.getAttribute('data-cart-total-count'), 10) || 0);
      }
    }

    function cartRequest(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    // Add to cart: intercept any product form and open the drawer instead of navigating.
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[name="add"], [type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      var fd = new FormData(form);
      fd.append('sections', SECTION);
      fd.append('sections_url', window.location.pathname);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status && data.status !== 200) return; // sold out / error: leave page as-is
          if (data && data.sections) applySection(data.sections[SECTION]);
          openDrawer();
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });

    // Change quantity / remove.
    function changeLine(line, qty) {
      cartRequest('/cart/change.js', { line: line, quantity: qty, sections: SECTION, sections_url: window.location.pathname })
        .then(function (data) {
          if (data && data.sections) applySection(data.sections[SECTION]);
        });
    }

    // Delegated clicks: toggle, close, qty steppers, remove.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

      var minus = e.target.closest('[data-cart-minus]');
      var plus = e.target.closest('[data-cart-plus]');
      var remove = e.target.closest('[data-cart-remove]');
      if (minus || plus || remove) {
        var el = minus || plus || remove;
        var line = parseInt(el.getAttribute('data-cart-minus') || el.getAttribute('data-cart-plus') || el.getAttribute('data-cart-remove'), 10);
        var li = el.closest('[data-cart-line]');
        var cur = li ? parseInt(li.querySelector('[data-cart-qty]').textContent, 10) : 1;
        if (remove) changeLine(line, 0);
        else if (minus) changeLine(line, Math.max(0, cur - 1));
        else changeLine(line, cur + 1);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-faq-search]');
    if (!input) return;
    var root = input.closest('.faq');
    var q = input.value.trim().toLowerCase();
    var any = false;
    root.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var match = !q || item.getAttribute('data-faq-q').indexOf(q) !== -1;
      item.hidden = !match;
      if (match) any = true;
    });
    var empty = root.querySelector('[data-faq-empty]');
    if (empty) empty.hidden = any;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founders-choice"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fc]').forEach(function (root) {
      var track = root.querySelector('[data-fc-track]');
      if (!track) return;
      function step() { var c = track.querySelector('.fc__card'); return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.5; }
      var prev = root.querySelector('[data-fc-prev]');
      var next = root.querySelector('[data-fc-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    // Drawer accordion: expand/collapse a parent's sub-list.
    var dtoggle = e.target.closest('.header__drawer-toggle');
    if (dtoggle) {
      var row = dtoggle.closest('.header__drawer-row');
      var sub = row ? row.nextElementSibling : null;
      if (sub && sub.classList.contains('header__drawer-sub')) {
        var willOpen = sub.hidden;
        sub.hidden = !willOpen;
        dtoggle.setAttribute('aria-expanded', String(willOpen));
        dtoggle.classList.toggle('is-open', willOpen);
      }
      return;
    }

    var toggle = e.target.closest('.header__toggle');
    if (toggle) {
      var header = toggle.closest('.header');
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      header.classList.toggle('header--open', open);
      return;
    }
    var openHeader = document.querySelector('.header--open');
    if (openHeader && !e.target.closest('.header')) {
      openHeader.classList.remove('header--open');
      var t = openHeader.querySelector('.header__toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.header--open').forEach(function (header) {
      header.classList.remove('header--open');
      var t = header.querySelector('.header__toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  // Transparent header flips to the solid look once scrolled, AND the bar
  // hides on scroll-down / reappears on scroll-up.
  (function () {
    var ticking = false;
    var lastY = window.pageYOffset;
    function apply() {
      ticking = false;
      var y = window.pageYOffset;
      var scrolled = y > 40;
      document.querySelectorAll('.header--transparent').forEach(function (h) {
        h.classList.toggle('header--scrolled', scrolled);
      });

      var header = document.querySelector('.header');
      if (header) {
        var h = header.offsetHeight;
        // Always show near the top, while hovering the bar (mega open), or with
        // the mobile drawer open. Otherwise hide going down, show going up.
        if (y <= h || header.matches(':hover') || header.classList.contains('header--open')) {
          header.classList.remove('header--hidden');
        } else if (y > lastY + 4) {
          header.classList.add('header--hidden');
        } else if (y < lastY - 4) {
          header.classList.remove('header--hidden');
        }
      }
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
  })();

  // Search popup: open under the bar and focus the field; Enter submits the
  // form (GET) to the search results page.
  (function () {
    var toggle = document.querySelector('[data-search-toggle]');
    var popup = document.querySelector('[data-search-popup]');
    if (!toggle || !popup) return;
    var input = popup.querySelector('[data-search-input]');
    function open() { popup.hidden = false; toggle.setAttribute('aria-expanded', 'true'); if (input) input.focus(); }
    function close() { popup.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
    toggle.addEventListener('click', function (e) { e.preventDefault(); if (popup.hidden) open(); else close(); });
    document.addEventListener('click', function (e) {
      if (popup.hidden) return;
      if (e.target.closest('[data-search-close]')) { close(); return; }
      if (!e.target.closest('[data-search-popup]') && !e.target.closest('[data-search-toggle]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });
  })();

  // Keep the spacer height in sync with the fixed header.
  (function () {
    function setH() {
      var h = document.querySelector('.header');
      if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
    }
    window.addEventListener('resize', setH, { passive: true });
    setH();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal"]) return;
  try {
    
  document.querySelectorAll('[data-legal]').forEach(function (root) {
    var content = root.querySelector('[data-legal-content]');
    var toc = root.querySelector('[data-legal-toc]');
    if (!content || !toc) return;
    var heads = content.querySelectorAll('h2, h3');
    var links = [];
    heads.forEach(function (h, i) {
      var num = ('0' + (i + 1)).slice(-2);
      if (!h.id) { h.id = 'legal-section-' + (i + 1); }
      h.setAttribute('data-num', num);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.className = 'legal__toc-link';
      a.innerHTML = '<span class="legal__toc-num">' + num + '</span><span>' + h.textContent + '</span>';
      toc.appendChild(a);
      links.push(a);
    });
    if (!('IntersectionObserver' in window) || !heads.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var id = e.target.id;
        links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + id); });
      });
    }, { rootMargin: '-10% 0px -75% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-filter-form]').forEach(function (form) {
      var section = form.closest('.collection');
      if (!section) return;
      var desktop = window.matchMedia('(min-width: 990px)');

      // Auto-apply when a facet checkbox or the sort changes (price uses its Apply button).
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select[name="sort_by"]')) {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        }
      });

      // One toggle: collapses the sidebar on desktop, opens the drawer on mobile.
      function toggle() {
        if (desktop.matches) {
          section.classList.toggle('collection--filters-collapsed');
        } else {
          var open = !section.classList.contains('collection--filters-open');
          section.classList.toggle('collection--filters-open', open);
          document.body.classList.toggle('filters-open', open);
        }
      }
      form.querySelectorAll('[data-filters-toggle]').forEach(function (btn) {
        btn.addEventListener('click', toggle);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && section.classList.contains('collection--filters-open')) {
          section.classList.remove('collection--filters-open');
          document.body.classList.remove('filters-open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-events"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ev__list').forEach(function (list) {
      var initial = parseInt(getComputedStyle(list).getPropertyValue('--initial'), 10) || 3;
      var rows = Array.prototype.slice.call(list.querySelectorAll('.ev__row'));
      if (rows.length <= initial) return;
      rows.forEach(function (row, i) { if (i >= initial) row.classList.add('is-hidden'); });
      var section = list.closest('.ev');
      var btn = section && section.querySelector('[data-ev-more]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        rows.forEach(function (row) { row.classList.remove('is-hidden'); });
        btn.parentNode.removeChild(btn);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  // Size guide modal open/close.
  (function () {
    var modal = document.querySelector('[data-size-guide]');
    if (!modal) return;
    function open() { modal.hidden = false; document.body.classList.add('szg-open'); }
    function close() { modal.hidden = true; document.body.classList.remove('szg-open'); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-guide-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-size-guide-close]')) { close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  })();

  document.querySelectorAll('.pdp').forEach(function (root) {
    var mediaEl = root.querySelector('[data-pdp-media]');
    var galEl = root.querySelector('[data-variant-galleries]');
    var mainImg = root.querySelector('.pdp__main-img');
    var thumbsWrap = root.querySelector('.pdp__thumbs');
    var media = mediaEl ? JSON.parse(mediaEl.textContent) : [];
    var galleries = galEl ? JSON.parse(galEl.textContent) : {};
    var current = media;

    function setMain(m) { if (mainImg && m) { mainImg.srcset = ''; mainImg.src = m.url; if (m.alt) mainImg.alt = m.alt; } }
    function renderThumbs(list) {
      if (!thumbsWrap) return;
      thumbsWrap.innerHTML = list.map(function (m, i) {
        return '<button class="pdp__thumb' + (i === 0 ? ' is-active' : '') + '" type="button" data-gallery-index="' + i + '" aria-label="View image"><img src="' + m.thumb + '" alt="" loading="lazy"></button>';
      }).join('');
    }
    // Show the selected variant's gallery (custom.variant_gallery, keyed by colour); fall back to all media.
    function applyGallery(key) {
      var g = key != null ? galleries[key] : null;
      var list = (g && g.length) ? g : media;
      if (!list.length) return;
      current = list;
      renderThumbs(list);
      setMain(list[0]);
    }
    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (e) {
        var t = e.target.closest('[data-gallery-index]');
        if (!t) return;
        setMain(current[+t.getAttribute('data-gallery-index')]);
        thumbsWrap.querySelectorAll('.pdp__thumb').forEach(function (b) { b.classList.toggle('is-active', b === t); });
      });
    }

    var vEl = root.querySelector('[data-pdp-variants]');
    var variants = vEl ? JSON.parse(vEl.textContent) : [];
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-btn]');
    var addText = root.querySelector('[data-add-text]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var colorFs = root.querySelector('[data-color-option]');
    function currentColor() {
      if (!colorFs) return null;
      var c = colorFs.querySelector('input:checked');
      return c ? c.value.toLowerCase() : null;
    }
    function money(cents) { return '$' + (cents / 100).toFixed(2); }
    function galleryKey(match) {
      var col = currentColor();
      if (col != null) return col;
      return match ? String(match.id) : null;
    }

    var lastKey;
    function update() {
      var chosen = [];
      root.querySelectorAll('.pdp__option').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        chosen.push(checked ? checked.value : null);
        var sel = fs.querySelector('[data-option-selected]');
        if (sel && checked) sel.textContent = checked.value;
      });
      var match = variants.find(function (v) {
        return (v.options || []).every(function (o, i) { return o === chosen[i]; });
      });
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (addBtn && addText) {
          addBtn.disabled = !match.available;
          addText.textContent = match.available ? (addBtn.getAttribute('data-add-avail') || 'Add to Cart') : 'Sold out';
        }
      }
      // Only rebuild the gallery when the variant's gallery key (colour) changes.
      var key = galleryKey(match);
      if (key !== lastKey) { lastKey = key; applyGallery(key); }
    }
    if (addText && addBtn) addBtn.setAttribute('data-add-avail', addText.textContent);
    root.querySelectorAll('[data-option-input]').forEach(function (i) { i.addEventListener('change', update); });

    var initialMatch = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || variants[0];
    lastKey = galleryKey(initialMatch);
    applyGallery(lastKey);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-shop-all"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.shopall__tab');
    if (!tab) return;
    var root = tab.closest('.shopall');
    var idx = tab.getAttribute('data-tab');
    root.querySelectorAll('.shopall__tab').forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
    root.querySelectorAll('.shopall__panel').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === idx); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pug]').forEach(function (root) {
      var track = root.querySelector('[data-pug-track]');
      if (!track) return;
      var prev = root.querySelector('[data-pug-prev]');
      var next = root.querySelector('[data-pug-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-prc]').forEach(function (root) {
      var steps = root.querySelectorAll('.prc__step');
      var panels = root.querySelectorAll('.prc__panel');
      var n = steps.length;
      if (n < 2) return;
      var current = 0;
      function setActive(i) {
        if (i === current) return;
        current = i;
        steps.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
        panels.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      }
      // click a step -> just make it active (no page scroll)
      steps.forEach(function (el) {
        el.addEventListener('click', function () {
          setActive(parseInt(el.getAttribute('data-prc-step'), 10));
        });
      });
      var ticking = false;
      function update() {
        ticking = false;
        var rect = root.getBoundingClientRect();
        var dist = root.offsetHeight - window.innerHeight;
        if (dist <= 0) { setActive(0); return; }
        var p = (-rect.top) / dist;
        p = Math.max(0, Math.min(0.99999, p));
        setActive(Math.floor(p * n));
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-tl]').forEach(function (root) {
      var entries = root.querySelectorAll('.tl__entry');
      var imgs = root.querySelectorAll('.tl__img');
      var n = entries.length;
      if (n < 2) return;
      var current = 0;
      function setActive(i) {
        if (i === current) return;
        current = i;
        entries.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
        imgs.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      }
      var ticking = false;
      function update() {
        ticking = false;
        var rect = root.getBoundingClientRect();
        var dist = root.offsetHeight - window.innerHeight;
        if (dist <= 0) return;
        var p = (-rect.top) / dist;
        p = Math.max(0, Math.min(0.99999, p));
        setActive(Math.floor(p * n));
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
